import { Users } from "lucide-react";

const MembersIcon = (props) => <Users strokeWidth={1.5} {...props} />;

export default MembersIcon;
